import { CustomerFormPrefixes } from '@components/CreateCustomer/components/CreateCustomerForm/CreateCustomerFormDefinitions';
import { createContext } from 'react';
import { FormAddressType } from '../components/AddressForm';
import { SuggestedAddress } from '@api/generated/graphql';

export type SelectedSuggestedAddressType = FormAddressType | undefined;

export interface AddressFormManagerContextType {
  suggestedAddresses: SuggestedAddress[];
  loadingSuggestedAddresses: boolean;
  selectedSuggestedAddress: SelectedSuggestedAddressType;
  handleSuggestedAddressClick: (placeId: string) => void;
  isSuggestedAddressUsed: boolean;
  formFieldPrefix: CustomerFormPrefixes;
  showFullForm: (address?: FormAddressType) => void;
  hideFullForm: () => void;
}

const AddressFormManagerContext = createContext<
  AddressFormManagerContextType | undefined
>(undefined);

export default AddressFormManagerContext;
